'use strict';

const RequestHandler = require('./../../../core/requestHandler');
const baseType = 'knowledge-graph';

module.exports.getParameters = function() {
  let dfd;
  let currentApiUrl = RequestHandler.getBaseUrl();

  RequestHandler.setBaseUrl('/api');
  dfd = RequestHandler.read(baseType + '/parameters');
  RequestHandler.setBaseUrl(currentApiUrl);

  return dfd;
};
